import { SVGProps, Ref, forwardRef } from 'react';

export const BriefcaseFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.725 5C9.393 3.607 10.372 2.8 12 2.8s2.607.807 3.275 2.2zm-1.954.013C7.622 2.68 9.25 1 12 1s4.378 1.68 5.23 4.013c4.85.11 6.302 1.003 6.663 4.987H.107c.36-3.984 1.812-4.877 6.664-4.987M.015 11.8C-.01 12.866.003 13.933.003 15c0 7 1 8 7.998 8h7.998c6.998 0 7.998-1 7.998-8 0-1.066.012-2.134-.012-3.2zM15.499 16H8.501v-1.8h6.998z"
                fill="currentColor"
            />
        </g>
    </svg>
));
BriefcaseFilledSize24Glyph.displayName = 'BriefcaseFilledSize24Glyph';
